export class HamburgerItemConstants {
    public static SHOP = 'shop';
    public static JOIN = 'join';
    public static ABOUT = 'about';
    public static LOGIN = 'login';
    public static RETAILSITE = 'retailsite';
    public static CORPORATE = 'corporate';
}
